'use strict';

angular.module('substoreApp.controllers')
    .controller('productdetailsController', ProductdetailsController);

function ProductdetailsController($scope, $routeParams, $translate, dialogData, uiservice, sessionData, productDataCollector, productDataFinalizer, htmlTruster, webtrekk) {

    var subscriptionTemplateId = $routeParams.subscriptionTemplateId;

    sessionData.transient.subscriptionTemplateId = subscriptionTemplateId;

    $scope.isCatalogueActive = true;
    $scope.btn_next_active = false;

    $scope.breadcrumb.init("navigation_catalogue", "#/");

    $scope.hasUndefinedAvailability = productDataFinalizer.hasUndefinedAvailability;
    $scope.hasNoneAvailability = productDataFinalizer.hasNoneAvailability;
    $scope.isAvailable = productDataFinalizer.isAvailable;

    $scope.isDescriptionExpanded = true;
    $scope.isRequirementsExpanded = true;
    $scope.isPriceinformationExpanded = true;
    $scope.isGalleryExpanded = true;
    $scope.isProductGroupExpanded = true;

    function updateNextButton(product) {
        $scope.btn_next_active = product.bookingAllowed;
        $translate([
                'productdetails_btn_order',
                'productdetails_btn_order_complete',
                'productdetails_btn_order_reserved',
                'productdetails_btn_order_alreadybooked',
                'productdetails_btn_order_excludedby',
                'productdetails_btn_order_notallowed',
                'msg_order_currently_not_possible'
            ],
            {excludedBy: product.excludedBy != null && product.excludedBy.length > 0 ? product.excludedBy[0].productName : null})
            .then(function (translations) {
                var translationKey;
                if (product.bookingAllowed)
                    if (product.reservedInstances > 0)
                        translationKey = 'productdetails_btn_order_complete';
                    else
                        translationKey = 'productdetails_btn_order';
                else if (product.canNotSucceed)
                    translationKey = 'msg_order_currently_not_possible';
                else if (product.reservedInstances > 0)
                    translationKey = 'productdetails_btn_order_reserved';
                else if (product.currentInstances >= product.maxInstances)
                    translationKey = 'productdetails_btn_order_alreadybooked';
                else if (product.excludedBy != null && product.excludedBy.length > 0)
                    translationKey = 'productdetails_btn_order_excludedby';
                else
                    translationKey = 'productdetails_btn_order_notallowed';
                $scope.msg_btn_next = translations[translationKey];
            });
    }

    function initDialogData() {
        $scope.data = dialogData;

        var product = dialogData.product;
        productDataCollector.collectWithGallery(product);
        productDataFinalizer.checkAvailability(product);

        $scope.breadcrumb.add(product.texts.productName);

        $scope.updateTeaser(
            product.texts.headerTitleDetails,
            product.texts.headerSubTitleDetails,
            product.images.headerImageDetailsResourcePath);

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        updateNextButton(product);

        $scope.selection = {
            ordered: -1,
            subscriptionTemplateId: null,
            productName: product.texts.productName,
            productSubscriptionType: product.texts.productSubscriptionType,
            regularPriceOverrideText: product.texts.regularPriceOverrideText,
            promotionPriceOverrideText: product.texts.promotionPriceOverrideText,
            minimumCommitmentPeriodText: product.texts.minimumCommitmentPeriodText,
            minimumCommitmentPeriodOverrideText: product.texts.minimumCommitmentPeriodOverrideText,
            promotionProcessing: product.promotionProcessing,
            price: product.price,
            members: (product.productGroup ? product.productGroupMembers : [] ),
            init: function () {
                if (product.productGroup) {
                    // assign natural order to members
                    // (currently we do not get some from server)
                    for (var i = 0; i < product.productGroupMembers.length; i++)
                        this.members[i].order = i;
                    if (product.productGroupMembers.length)
                        this.ordered = 0;
                }
            },
            apply: function () {
                // here we do support two selection models:
                // partner features might identify chosen item
                // by order (as of 'natural order') or by
                // subscriptionTemplateId
                var ordered = this.ordered;
                if (ordered === -1 && this.subscriptionTemplateId) {
                    for (var i = 0; i < this.members.length; i++)
                        if (this.subscriptionTemplateId === this.members[i].subscriptionTemplateId) {
                            ordered = i;
                            break;
                        }
                }
                if (ordered >= 0) {
                    var member = this.members[ordered];
                    this.subscriptionTemplateId = member.subscriptionTemplateId;
                    this.productName = member.productName;
                    this.productSubscriptionType = member.productSubscriptionType;
                    this.regularPriceOverrideText = member.regularPriceOverrideText;
                    this.promotionPriceOverrideText = member.promotionPriceOverrideText;
                    this.minimumCommitmentPeriodText = member.minimumCommitmentPeriodText;
                    this.minimumCommitmentPeriodOverrideText = member.minimumCommitmentPeriodOverrideText;
                    this.promotionProcessing = member.promotionProcessing;
                    this.price = member.price;
                    updateNextButton(member);
                } else {
                    this.subscriptionTemplateId = (product.productGroup ? null : product.subscriptionTemplateId);
                    this.productName = product.texts.productName;
                    this.productSubscriptionType = product.texts.productSubscriptionType;
                    this.regularPriceOverrideText = product.texts.regularPriceOverrideText;
                    this.promotionPriceOverrideText = product.texts.promotionPriceOverrideText;
                    this.minimumCommitmentPeriodText = product.texts.minimumCommitmentPeriodText;
                    this.minimumCommitmentPeriodOverrideText = product.texts.minimumCommitmentPeriodOverrideText;
                    this.promotionProcessing = product.promotionProcessing;
                    this.price = product.price;
                    updateNextButton(product);
                }
            },
            partnerFeatureSource: $scope.lookupFeature([$scope.data.partnerName, 'productdetails', 'group'])
        };

        $scope.selection.init();

        $scope.applyFeature($scope, [$scope.data.partnerName, 'productdetails', 'dialog']);

        $scope.selection.apply();

        webtrekk.track('productdetails', {
            shop_product_sku: product.subscriptionTemplateId,
            shop_product_status: "view",
            shop_product_name: product.texts.productName
        });
    }

    // configure routing dialog functions

    $scope.nextClicked = false;

    $scope.next = function () {
        if ($scope.nextClicked)
            return;
        $scope.nextClicked = true;

        var result = $scope.applyFeature($scope, [$scope.data.partnerName, 'productdetails', 'next']);
        // result is either true or false or generic partner data
        if (result) {
            var genericPartnerData = (typeof result === 'object') ? result : null;
            uiservice.productDetailsAction({
                    sessionId: sessionData.sessionId,
                    subscriptionTemplateId: $scope.selection.subscriptionTemplateId,
                    genericPartnerData: genericPartnerData
                },
                function success(response) {
                    $scope.go("/orderselection/" + $scope.selection.subscriptionTemplateId);
                },
                $scope.throwServiceResponseFault
            );
        }
    };

    $scope.galleryClicked = function () {
        webtrekk.track('productdetailsgallery', {
            shop_product_sku: subscriptionTemplateId
        });
    };

    $scope.backAllowed = function () {
        return sessionData.transient.deeplinkedPage !== 'PRODUCTDETAILPAGE';
    };

    $scope.$on("$locationChangeStart",
        function (event, next, current) {
            sessionData.transient.deeplinkedPage = null;
        });

    initDialogData();
}